<template>
  <v-card class="ui-module-card" color="primary">
    <v-card-title class="ui-module-titlebar font-weight-bold justify-center">Registro de capacitador</v-card-title>
    <v-card-text>
      <v-form v-model="trainerForm">
        <v-container>
          <v-row>
            <!-- Toggle tipo capacitador -->
            <v-col cols="12" class="d-flex justify-center pb-2">
              <v-btn-toggle v-model="tipoCapacitador" mandatory color="secondary" rounded class="ui-toggle-switch">
                <v-btn value="capacitador" class="px-6">Capacitador</v-btn>
                <v-btn value="institucion" class="px-6">Institución responsable</v-btn>
              </v-btn-toggle>
            </v-col>

            <!-- Campos capacitador individual -->
            <template v-if="tipoCapacitador === 'capacitador'">
              <v-col cols="12">
                <v-text-field
                  class="ui-form-field"
                  v-model="capacitador.nombre"
                  rounded
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  :rules="nameRules"
                >
                  <template v-slot:label>Nombre <span class="red--text">*</span> </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  class="ui-form-field"
                  v-model="capacitador.segundoNombre"
                  rounded
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  label="Segundo nombre"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  class="ui-form-field"
                  v-model="capacitador.apaterno"
                  rounded
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  :rules="nameRules"
                >
                  <template v-slot:label>Apellido paterno <span class="red--text">*</span> </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  class="ui-form-field"
                  v-model="capacitador.amaterno"
                  rounded
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  :rules="nameRules"
                >
                  <template v-slot:label>Apellido materno <span class="red--text">*</span> </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  class="ui-form-field"
                  v-model="capacitador.file"
                  persistent-hint
                  rounded
                  filled
                  background-color="transparent"
                  color="secondary"
                  dense
                  :rules="nameRules"
                >
                  <template v-slot:label>Adjuntar certificado o título <span class="red--text">*</span> </template>
                </v-file-input>
              </v-col>
            </template>

            <!-- Campos institución responsable -->
            <template v-else>
              <v-col cols="12">
                <v-text-field
                  class="ui-form-field"
                  v-model="institucion.nombre"
                  rounded
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  :rules="nameRules"
                >
                  <template v-slot:label>Nombre de la institución <span class="red--text">*</span> </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  class="ui-form-field"
                  v-model="institucion.file"
                  persistent-hint
                  rounded
                  filled
                  background-color="transparent"
                  color="secondary"
                  dense
                  :rules="nameRules"
                >
                  <template v-slot:label>Adjuntar certificado o título <span class="red--text">*</span> </template>
                </v-file-input>
              </v-col>
            </template>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-center pb-8 ui-module-actions">
      <v-btn text class="ui-module-btn-outline px-8" v-on:click="$router.go(-1)">Cancelar</v-btn>
      <v-btn
        color="secondary"
        class="ui-module-btn-solid px-8"
        :disabled="!trainerForm || loading"
        v-on:click="triggerSaveTrainer()"
        >Registrar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      trainerForm: false,
      tipoCapacitador: 'capacitador',
      capacitador: {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        certificado: '',
        file: null,
      },
      institucion: {
        nombre: '',
        file: null,
      },

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  methods: {
    ...mapActions('capacitador', ['saveCapacitador', 'fetchCapacitadores']),

    triggerSaveTrainer: async function () {
      this.loading = true

      if (this.tipoCapacitador === 'capacitador') {
        this.capacitador.certificado = this.capacitador.file.name
        await this.saveCapacitador(this.capacitador)
      } else {
        const payload = {
          nombre: this.institucion.nombre,
          segundoNombre: '',
          apaterno: '-',
          amaterno: '-',
          certificado: this.institucion.file.name,
          file: this.institucion.file,
        }
        await this.saveCapacitador(payload)
      }

      await this.fetchCapacitadores()
      this.$router.push('/profesionalizacion/capacitadores')

      this.loading = false
    },
  },
}
</script>

<style scoped>
::v-deep .ui-toggle-switch {
  background: rgba(26, 46, 36, 0.6) !important;
  border: 1px solid rgba(0, 210, 160, 0.2) !important;
  border-radius: 12px !important;
}

::v-deep .ui-toggle-switch .v-btn {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

::v-deep .ui-toggle-switch .v-btn--active {
  background: rgba(0, 210, 160, 0.18) !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-file-input__text,
::v-deep .ui-form-field .mdi-paperclip {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #26de81 !important;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #062118 !important;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.28) !important;
}

::v-deep .ui-module-actions .ui-module-btn-outline {
  background: rgba(0, 210, 160, 0.08) !important;
  border: 1px solid rgba(0, 210, 160, 0.35) !important;
  color: #26de81 !important;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 210, 160, 0.25) !important;
}

.red--text {
  color: #ff5252 !important;
}
</style>
